import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Sitemap } from '../components/Sitemap';
import { BookIcon, BookOpenIcon, CalendarIcon, ChevronDownIcon, ClockIcon, ExternalLinkIcon, SearchIcon, TagIcon, ThumbsUpIcon, UserIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const BLOG_POSTS = [{
  id: 1,
  title: {
    en: 'Top 5 English Learning Books for Beginners',
    ar: 'أفضل 5 كتب لتعلم اللغة الإنجليزية للمبتدئين'
  },
  excerpt: {
    en: 'Discover the most effective books to kickstart your English learning journey with our expert recommendations.',
    ar: 'اكتشف أكثر الكتب فعالة لبدء رحلة تعلم اللغة الإنجليزية مع توصيات خبرائنا.'
  },
  image: 'https://images.unsplash.com/photo-1491841550275-ad7854e35ca6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  author: 'Sarah Ahmed',
  date: '2024-05-10',
  readTime: 8,
  category: 'reviews',
  tags: ['books', 'beginners', 'resources'],
  hasAffiliateLinks: true
}, {
  id: 2,
  title: {
    en: 'How to Improve Your English Pronunciation',
    ar: 'كيفية تحسين نطق اللغة الإنجليزية'
  },
  excerpt: {
    en: 'Learn practical techniques to enhance your English pronunciation and sound more like a native speaker.',
    ar: 'تعلم تقنيات عملية لتحسين نطقك للغة الإنجليزية والتحدث بطريقة أقرب للمتحدثين الأصليين.'
  },
  image: 'https://images.unsplash.com/photo-1543165796-5b4fb5188930?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  author: 'Mohammed Al-Farsi',
  date: '2024-05-05',
  readTime: 6,
  category: 'learning',
  tags: ['pronunciation', 'speaking', 'tips'],
  hasAffiliateLinks: false
}, {
  id: 3,
  title: {
    en: 'Best Online Courses for Business English',
    ar: 'أفضل الدورات عبر الإنترنت للإنجليزية التجارية'
  },
  excerpt: {
    en: 'Comprehensive review of the top online courses to master Business English for your career advancement.',
    ar: 'مراجعة شاملة لأفضل الدورات التدريبية عبر الإنترنت لإتقان اللغة الإنجليزية التجارية لتطوير حياتك المهنية.'
  },
  image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  author: 'Layla Mahmoud',
  date: '2024-04-28',
  readTime: 10,
  category: 'reviews',
  tags: ['business', 'courses', 'professional'],
  hasAffiliateLinks: true
}, {
  id: 4,
  title: {
    en: '7 Daily Habits to Accelerate Your English Learning',
    ar: '7 عادات يومية لتسريع تعلم اللغة الإنجليزية'
  },
  excerpt: {
    en: 'Simple yet powerful daily habits that can significantly improve your English skills over time.',
    ar: 'عادات يومية بسيطة ولكنها قوية يمكن أن تحسن مهاراتك في اللغة الإنجليزية بشكل كبير مع مرور الوقت.'
  },
  image: 'https://images.unsplash.com/photo-1506784983877-45594efa4cbe?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  author: 'Ahmed Hassan',
  date: '2024-04-20',
  readTime: 5,
  category: 'learning',
  tags: ['habits', 'learning', 'tips'],
  hasAffiliateLinks: false
}, {
  id: 5,
  title: {
    en: 'Essential Apps and Tools for English Learners',
    ar: 'تطبيقات وأدوات أساسية لمتعلمي اللغة الإنجليزية'
  },
  excerpt: {
    en: 'Discover the most effective digital tools and applications to enhance your English learning experience.',
    ar: 'اكتشف أكثر الأدوات الرقمية والتطبيقات فعالية لتعزيز تجربة تعلم اللغة الإنجليزية.'
  },
  image: 'https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  author: 'Noor Al-Sayed',
  date: '2024-04-15',
  readTime: 7,
  category: 'reviews',
  tags: ['tools', 'apps', 'technology'],
  hasAffiliateLinks: true
}, {
  id: 6,
  title: {
    en: 'Common English Grammar Mistakes Arabic Speakers Make',
    ar: 'أخطاء نحوية شائعة في اللغة الإنجليزية يرتكبها المتحدثون بالعربية'
  },
  excerpt: {
    en: 'Learn how to identify and correct the most common grammar mistakes made by Arabic speakers learning English.',
    ar: 'تعلم كيفية تحديد وتصحيح أكثر الأخطاء النحوية شيوعًا التي يرتكبها المتحدثون بالعربية عند تعلم اللغة الإنجليزية.'
  },
  image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  author: 'Fatima Al-Zahra',
  date: '2024-04-08',
  readTime: 9,
  category: 'learning',
  tags: ['grammar', 'mistakes', 'tips'],
  hasAffiliateLinks: false
}];
const CATEGORIES = [{
  id: 'all',
  label: {
    en: 'All Posts',
    ar: 'جميع المقالات'
  }
}, {
  id: 'reviews',
  label: {
    en: 'Reviews',
    ar: 'المراجعات'
  }
}, {
  id: 'learning',
  label: {
    en: 'Learning Tips',
    ar: 'نصائح التعلم'
  }
}, {
  id: 'news',
  label: {
    en: 'News',
    ar: 'الأخبار'
  }
}];
export function Blog() {
  const {
    isArabic
  } = useLanguage();
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const filteredPosts = BLOG_POSTS.filter(post => {
    const matchesCategory = activeCategory === 'all' || post.category === activeCategory;
    const matchesSearch = searchQuery === '' || post.title[isArabic ? 'ar' : 'en'].toLowerCase().includes(searchQuery.toLowerCase()) || post.excerpt[isArabic ? 'ar' : 'en'].toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    if (isArabic) {
      const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      };
      return date.toLocaleDateString('ar-EG', options);
    } else {
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }
  };
  return <div className="w-full px-6 md:px-10 lg:px-20 py-16" data-id="element-2290">
      <Sitemap currentPage={{
      en: 'Blog',
      ar: 'المدونة'
    }} data-id="element-2291" />
      <div className="max-w-7xl mx-auto" data-id="element-2292">
        <div className="text-center mb-12" data-id="element-2293">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-2294">
            {isArabic ? 'المدونة' : 'Blog'}
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto" data-id="element-2295">
            {isArabic ? 'مقالات ومراجعات ونصائح لمساعدتك في رحلة تعلم اللغة الإنجليزية' : 'Articles, reviews, and tips to help you on your English learning journey'}
          </p>
        </div>
        <div className="mb-10 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-2296">
          <div className="relative w-full md:max-w-md" data-id="element-2297">
            <SearchIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 dark:text-gray-500" data-id="element-2298" />
            <input type="text" placeholder={isArabic ? 'ابحث في المدونة...' : 'Search blog...'} className="w-full pl-12 pr-4 py-3 rounded-xl bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-transparent transition-all duration-200" dir={isArabic ? 'rtl' : 'ltr'} value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-2299" />
          </div>
          <div className="flex overflow-x-auto space-x-4 w-full md:w-auto pb-2 md:pb-0" data-id="element-2300">
            {CATEGORIES.map(category => <button key={category.id} className={`px-4 py-2 rounded-full whitespace-nowrap ${activeCategory === category.id ? 'bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 font-medium' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'}`} onClick={() => setActiveCategory(category.id)} data-id="element-2301">
                {isArabic ? category.label.ar : category.label.en}
              </button>)}
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-2302">
          {filteredPosts.map(post => <Link key={post.id} to={`/blog/post/${post.id}`} className="bg-white dark:bg-gray-800 rounded-xl shadow-md hover:shadow-lg transition-all duration-200 overflow-hidden flex flex-col h-full" data-id="element-2303">
              <div className="relative" data-id="element-2304">
                <img src={post.image} alt={isArabic ? post.title.ar : post.title.en} className="w-full h-48 object-cover" data-id="element-2305" />
                {post.category === 'reviews' && <div className="absolute top-4 left-4 bg-blue-600 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-2306">
                    {isArabic ? 'مراجعة' : 'REVIEW'}
                  </div>}
                {post.hasAffiliateLinks && <div className="absolute top-4 right-4 bg-amber-100 text-amber-800 dark:bg-amber-900/50 dark:text-amber-300 text-xs font-bold px-2 py-1 rounded flex items-center gap-1" data-id="element-2307">
                    <ExternalLinkIcon className="w-3 h-3" data-id="element-2308" />
                    {isArabic ? 'روابط شريكة' : 'PARTNER LINKS'}
                  </div>}
              </div>
              <div className="p-5 flex-1 flex flex-col" data-id="element-2309">
                <div className="flex items-center text-sm text-gray-500 dark:text-gray-400 mb-3 gap-4" data-id="element-2310">
                  <div className="flex items-center gap-1" data-id="element-2311">
                    <CalendarIcon className="w-4 h-4" data-id="element-2312" />
                    <span data-id="element-2313">{formatDate(post.date)}</span>
                  </div>
                  <div className="flex items-center gap-1" data-id="element-2314">
                    <ClockIcon className="w-4 h-4" data-id="element-2315" />
                    <span data-id="element-2316">
                      {post.readTime} {isArabic ? 'دقائق' : 'min'}
                    </span>
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3" data-id="element-2317">
                  {isArabic ? post.title.ar : post.title.en}
                </h3>
                <p className="text-gray-600 dark:text-gray-300 mb-4 flex-1" data-id="element-2318">
                  {isArabic ? post.excerpt.ar : post.excerpt.en}
                </p>
                <div className="flex items-center justify-between mt-2" data-id="element-2319">
                  <div className="flex items-center gap-2" data-id="element-2320">
                    <div className="w-6 h-6 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center" data-id="element-2321">
                      <UserIcon className="w-3 h-3 text-blue-600 dark:text-blue-400" data-id="element-2322" />
                    </div>
                    <span className="text-sm text-gray-600 dark:text-gray-400" data-id="element-2323">
                      {post.author}
                    </span>
                  </div>
                  <div className="text-blue-600 dark:text-blue-400 text-sm font-medium" data-id="element-2324">
                    {isArabic ? 'اقرأ المزيد' : 'Read more'}
                  </div>
                </div>
              </div>
            </Link>)}
        </div>
        {filteredPosts.length === 0 && <div className="text-center py-16" data-id="element-2325">
            <div className="mb-4" data-id="element-2326">
              <SearchIcon className="w-12 h-12 mx-auto text-gray-400 dark:text-gray-500" data-id="element-2327" />
            </div>
            <h3 className="text-xl font-medium text-gray-900 dark:text-white mb-2" data-id="element-2328">
              {isArabic ? 'لم يتم العثور على نتائج' : 'No results found'}
            </h3>
            <p className="text-gray-600 dark:text-gray-400 max-w-md mx-auto" data-id="element-2329">
              {isArabic ? 'لم نتمكن من العثور على أي مقالات تطابق معايير البحث الخاصة بك. يرجى تجربة مصطلحات بحث مختلفة.' : "We couldn't find any articles matching your search criteria. Please try different search terms."}
            </p>
            <button onClick={() => {
          setSearchQuery('');
          setActiveCategory('all');
        }} className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-2330">
              {isArabic ? 'مسح البحث' : 'Clear search'}
            </button>
          </div>}
        <div className="mt-16 bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 rounded-2xl p-8" data-id="element-2331">
          <div className="max-w-3xl mx-auto text-center" data-id="element-2332">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-2333">
              {isArabic ? 'اشترك في النشرة الإخبارية' : 'Subscribe to our newsletter'}
            </h2>
            <p className="text-gray-600 dark:text-gray-300 mb-6" data-id="element-2334">
              {isArabic ? 'احصل على أحدث المقالات والنصائح والموارد مباشرة إلى بريدك الإلكتروني' : 'Get the latest articles, tips, and resources delivered straight to your inbox'}
            </p>
            <form className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto" data-id="element-2335">
              <input type="email" placeholder={isArabic ? 'بريدك الإلكتروني' : 'Your email address'} className="flex-1 px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400" dir={isArabic ? 'rtl' : 'ltr'} data-id="element-2336" />
              <button type="submit" className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium" data-id="element-2337">
                {isArabic ? 'اشترك' : 'Subscribe'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>;
}